import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { Injectable } from "@angular/core";
/**
 * 處理html後綴的自定義UrlSerializer，會在頁面的RouterLink產生對應的href屬性時執行
 * 將.html後綴移到最後面
 */
@Injectable()
export class HtmlSuffixURLSerializer extends DefaultUrlSerializer {
  // parse(url: string): UrlTree {
  //   const defaultUrlTree = super.parse(url);
  //   return defaultUrlTree;
  // }
  override serialize(tree: UrlTree): string {
    // 先取得預設Serialize的結果（此時.html後綴根據當前頁面可能會在中間或者不存在）
    const defaultUrl = super.serialize(tree);

    // 分離 URL 的主要部分和錨點部分
    const [urlWithoutFragment, fragment] = defaultUrl.split('#');
    const [path, query] = urlWithoutFragment.split('?');

     // 防止根路徑 `/` 被加成 `/.html`
     if (!path || path === '/') {
      return defaultUrl; // 保留原樣，不加 .html
    }

    // 如果本身已經有 .html，就不要再加
    if (path.endsWith('.html')) {
      return defaultUrl;
    }

    const processed = `${path}.html`;
    const withQuery = query ? `${processed}?${query}` : processed;
    return fragment ? `${withQuery}#${fragment}` : withQuery;

    // // 匹配是否存在.html後綴
    // const hasHtmlSuffixRegex = /\.html/;

    // // 處理不含錨點的部分
    // let processedUrl = urlWithoutFragment;

    // // 如果存在.html後綴，則進行網址分組的匹配
    // const replaceCenterHtmlSuffix = /([^/.]+?)\.html([^?]*?)(\?.*)?$/;
    // if (hasHtmlSuffixRegex.test(urlWithoutFragment)) {
    //   // 將前面網址跟後面網址合併，再加上.html後綴，最後再加上查詢參數（如果存在的話）
    //   processedUrl = urlWithoutFragment.replace(replaceCenterHtmlSuffix, '$1$2.html$3');
    // } else {
    //   // 如果沒有.html後綴，則直接加上.html後綴
    //   // 需要檢查是否已有查詢參數，以正確放置.html後綴
    //   const queryParamIndex = urlWithoutFragment.indexOf('?');
    //   if (queryParamIndex !== -1) {
    //     // 有查詢參數，將.html放在路徑與查詢參數之間
    //     processedUrl = urlWithoutFragment.substring(0, queryParamIndex) +
    //                    '.html' +
    //                    urlWithoutFragment.substring(queryParamIndex);
    //   } else {
    //     // 沒有查詢參數，直接在末尾加上.html
    //     processedUrl = `${urlWithoutFragment}.html`;
    //   }
    // }

    // // 重新組合URL，加上錨點（如果有的話）
    // return fragment ? `${processedUrl}#${fragment}` : processedUrl;
  }

}

